import styled from '@emotion/styled';
import {Button} from '@travel-frontend/ui-components';

export const CustomDialogBody = styled.div`
  padding: 0 20px 40px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: ${({theme}) => theme.colors.backgroundPrimary};

  ${Button} {
    margin-top: 8px;
  }

  img {
    width: 200px;
  }
`;
